import { CompilerOptions } from "typescript";
import { json, JsonApi } from "../json";

export interface TsConfig {
    extends?: string;
    compilerOptions: CompilerOptions;
    include?: string[];
    exclude?: string[];
    files?: string[];
    compileOnSave?: boolean;
    references?: { path: string }[];
    typeAcquisition: {
        enable?: boolean;
        include?: string[];
        exclude?: string[];
    };
}

export interface TsConfigApi extends JsonApi<TsConfig> {
    getOutDir(): Promise<string | undefined>;
    emitsCode(): Promise<boolean>;
}

const tsconfig = (path = "tsconfig.json"): TsConfigApi =>
    json.extend<Omit<TsConfigApi, keyof JsonApi>>((_, jsonApi) => ({
        ...jsonApi,
        getOutDir: () => jsonApi.getProperty(["compilerOptions", "outDir"]),
        emitsCode: async () =>
            !(await jsonApi.getProperty(["compilerOptions", "noEmit"])),
    }))(path);

export default tsconfig;
